"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormatEnum = exports.UNKNOWN_ENVIRONMENT_NAME = exports.VariationType = void 0;
var VariationType;
(function (VariationType) {
    VariationType["STRING"] = "STRING";
    VariationType["INTEGER"] = "INTEGER";
    VariationType["NUMERIC"] = "NUMERIC";
    VariationType["BOOLEAN"] = "BOOLEAN";
    VariationType["JSON"] = "JSON";
})(VariationType || (exports.VariationType = VariationType = {}));
exports.UNKNOWN_ENVIRONMENT_NAME = 'UNKNOWN';
var FormatEnum;
(function (FormatEnum) {
    FormatEnum["SERVER"] = "SERVER";
    FormatEnum["CLIENT"] = "CLIENT";
    FormatEnum["PRECOMPUTED"] = "PRECOMPUTED";
})(FormatEnum || (exports.FormatEnum = FormatEnum = {}));
//# sourceMappingURL=interfaces.js.map